import { ClaimValidationError } from '@/modules/UseMyMoney/UseMyMoney.types';
import { storeCreator } from '@/utils/store/store.utils';

export interface FormValues {
  amount?: string;
  customAmount?: string;
  providerId?: string;
  customProviderId?: string;
  patientId?: string;
  customPatientId?: string;
  dateOfService?: string;
  customDateOfService?: string;
  serviceId?: string;
  customServiceId?: string;
  paymentMethodId?: string;
  notes?: string;
  lmnId?: string;
  aiServicesSearchString?: string;
  isLmnWasUploaded?: boolean;
  createdClaimId?: string;
  isRunoutOverridden?: boolean;
}

interface StoreState {
  showUnsavedChangesPrompt: boolean;
  isAnimationPlayed: boolean;
  isClaimAutomaticallyApproved?: boolean;
  isClaimCreatedWithoutDocument?: boolean;
}

interface State extends StoreState {
  values: FormValues;
  handleSetState: (value: Partial<StoreState>) => void;
  handleSetFormValues: (value: Partial<FormValues>) => void;
  handleSetInitialFormValues: (value: Partial<FormValues>) => void;
  handleResetFormStore: () => void;
  validationErrors: ClaimValidationError[];
  setValidationErrors: (errors: ClaimValidationError[]) => void;
}

const DEFAULT_VALUES: FormValues = {
  amount: undefined,
  providerId: undefined,
  patientId: undefined,
  dateOfService: undefined,
  serviceId: undefined,
  paymentMethodId: undefined,
  notes: undefined,
  lmnId: undefined,
  aiServicesSearchString: undefined,
  isLmnWasUploaded: undefined,
  createdClaimId: undefined,
  isRunoutOverridden: undefined,
};

const useMyMoneyFormStore = storeCreator<State>((set) => ({
  values: DEFAULT_VALUES,
  validationErrors: [],
  showUnsavedChangesPrompt: true,
  isAnimationPlayed: false,

  handleSetFormValues: (value: Partial<FormValues>) =>
    set((state) => ({
      ...state,
      values: {
        ...state.values,
        ...value,
      },
    })),

  setValidationErrors: (errors: ClaimValidationError[]) =>
    set((state) => ({
      ...state,
      validationErrors: errors,
    })),

  handleSetInitialFormValues: (value: Partial<FormValues>) =>
    set((state) => ({
      ...state,
      values: {
        ...state.values,
        ...value,
      },
    })),

  handleSetState: (value: Partial<StoreState>) =>
    set((state) => ({
      ...state,
      ...value,
    })),

  handleResetFormStore: () =>
    set((state) => ({
      ...state,
      values: DEFAULT_VALUES,
      validationErrors: [],
      showUnsavedChangesPrompt: true,
      isAnimationPlayed: false,
    })),
}));

export default useMyMoneyFormStore;
